import { takeLatest, put } from 'redux-saga/effects'

import {
  depositCasino
} from '../../utils/apiCalls'

import {
  addDepositCompleted,
  addDepositFailure,
  addDepositStart,
  
} from '../redux-slices/tenantCasino'

import { objectToFormData } from '../../utils/objectToFormdata'
import { toast } from '../../components/Toast'
// import { TenantRoutes } from '../../routes'
import { serialize } from 'object-to-formdata'

export default function * tenantCasinoWatcher () {
  yield takeLatest(
    addDepositStart.type,
    addDepositWorker
  )

}

function * addDepositWorker (action) {
  try {
    const { data, handleClose } = action && action.payload
    yield depositCasino(data)
    yield toast("Bet Bonus added successfully", 'success')
    yield put(addDepositCompleted())
    handleClose()
  } catch (e) {
    yield toast(e?.response?.data?.errors[0]?.description, 'error')

    yield put(addDepositFailure())
  }
}

